export default __webpack_public_path__ + "static/media/821.71b6866c.gif";